import React, {Component} from 'react';
import {Route, withRouter} from 'react-router-dom';
import Button from 'material-ui/Button';
import 'jquery-slimscroll/jquery.slimscroll.min';
import tsl from '../../app/tsl';
import CalendarList from "components/CalendarList";
import { getSettings } from 'utils/client';


class SideNavContent extends Component {
    componentDidMount() {
        const {history} = this.props;
        const $nav = $(this.nav);
        const slideDuration = 250;

        $nav.slimscroll({
            height: '100%'
        });

        const pathname = `#${history.location.pathname}`;// get current path

        $("ul.nav-menu > li.menu").click(function () {
            const menuLi = this;
            $("ul.nav-menu > li.menu").not(menuLi).removeClass("open");
            $("ul.nav-menu > li.menu ul").not($("ul", menuLi)).slideUp(slideDuration);
            $("> ul", menuLi).slideToggle(slideDuration);
            $(menuLi).toggleClass("open");
        });

        $("ul.sub-menu li").click(function (e) {
            let superSubMenu = $(this).parent();
            if (superSubMenu.parent().hasClass("active")) {
                $("li", superSubMenu).not($(this)).removeClass("active");
            }
            else {
                $("ul.sub-menu li").not($(this)).removeClass("active");
            }

            $(this).toggleClass("active");
            e.stopPropagation();
        });

        const activeLi = $('a[href="' + pathname + '"]');// select current a element
        const activeNav = activeLi.closest("ul"); // select closest ul
        if (activeNav.hasClass("sub-menu")) {
            activeNav.slideDown(slideDuration);
            activeNav.parent().addClass("open");
            activeLi.parent().addClass("active");
        } else {
            activeLi.parent().addClass("open");
        }
    }


    render() {
        return (
            <ul className="nav-menu" ref={(c) => {
                this.nav = c;
            }}>

                <li className="nav-header">{tsl('menu.title')}</li>
                
                <li className="menu no-arrow">
                    <Button href="#/app/flights">
                        <i className="zmdi zmdi-chevron-right zmdi-hc-fw"/>
                        <span className="nav-text">{tsl('menu.flights')}</span>
                    </Button>
                </li>

                <li className="menu no-arrow">
                    <Button href="#/app/calendar">
                        <i className="zmdi zmdi-chevron-right zmdi-hc-fw"/>
                        <span className="nav-text">{tsl('menu.calendar')}</span>
                    </Button>
                </li>
                
                <li className="menu no-arrow">
                    <Button href="#/app/offers">
                        <i className="zmdi zmdi-chevron-right zmdi-hc-fw"/>
                        <span className="nav-text">{tsl('menu.offers')}</span>
                    </Button>
                </li>

                <li className="menu no-arrow">
                    <Button href="#/app/transfers">
                        <i className="zmdi zmdi-chevron-right zmdi-hc-fw"/>
                        <span className="nav-text">{tsl('menu.transfers')}</span>
                    </Button>
                </li>

                <li className="menu no-arrow">
                    <Button href="#/app/locations">
                        <i className="zmdi zmdi-chevron-right zmdi-hc-fw"/>
                        <span className="nav-text">{tsl('menu.locations')}</span>
                    </Button>
                </li>

                <li className="menu no-arrow">
                    <Button href="#/app/aircrafts">
                        <i className="zmdi zmdi-chevron-right zmdi-hc-fw"/>
                        <span className="nav-text">{tsl('menu.fleet')}</span>
                    </Button>
                </li>

                <li className="menu no-arrow">
                    <Button href="#/app/giftcards">
                        <i className="zmdi zmdi-chevron-right zmdi-hc-fw"/>
                        <span className="nav-text">{tsl('menu.vouchers')}</span>
                    </Button>
                </li>

                {
                  getSettings('enable_promo_codes') &&
                  <li className="menu no-arrow">
                    <Button href="#/app/promo-codes">
                      <i className="zmdi zmdi-chevron-right zmdi-hc-fw"/>
                      <span className="nav-text">{tsl('menu.promo_codes')}</span>
                    </Button>
                  </li>
                }

                <li className="menu no-arrow">
                    <Button href="#/app/requests">
                        <i className="zmdi zmdi-chevron-right zmdi-hc-fw"/>
                        <span className="nav-text">{tsl('menu.flight_requests')}</span>
                    </Button>
                </li>

                <li className="menu no-arrow">
                    <Button href="#/app/settings">
                        <i className="zmdi zmdi-chevron-right zmdi-hc-fw"/>
                        <span className="nav-text">{tsl('menu.settings')}</span>
                    </Button>
                </li>

                <li className="no-arrow">
                    <Route path="/app/calendar" component={CalendarList} />
                </li>
            </ul>
        );
    }
}

export default withRouter(SideNavContent);



// WEBPACK FOOTER //
// ./containers/SideNav/SidenavContent.js